import { createContext, useContext, type ReactNode } from 'react'

import type { DismissType } from './components/DismissInsightDialog'
import type { FeedbackDialogCloseReason } from './components/FeedbackDialog'

export type InsightMenuAction = 'helpful' | 'not_helpful' | 'hide'
export type InsightRating = 'helpful' | 'not_helpful'

export interface MenuActionHandlers {
  onAction: (action: InsightMenuAction) => void
  onOpen?: () => void
  disabled?: boolean
}

export interface UpdateParams {
  beatGuid: string
}

export interface FeedbackParams {
  beatGuid: string
  source: InsightRating | 'hide'
  option: string
  detail?: string
}

export interface DismissParams {
  beatGuid: string
  type: DismissType
}

/** Host callbacks for a beat card. */
export interface BeatActions {
  onMenuAction?: MenuActionHandlers
  onUpdate?: (params: UpdateParams) => void
  onSubmitFeedback?: (params: FeedbackParams) => void
  onDismissInsight?: (params: DismissParams) => void
  onUndoDismiss?: (params: { beatGuid: string }) => void
  onFeedbackDialogClose?: (reason: FeedbackDialogCloseReason) => void
  onFeedbackDialogBack?: () => void
  onFeedbackTextFocus?: () => void
}

const BeatActionsContext = createContext<BeatActions>({})

export const BeatActionsProvider = ({
  value,
  children,
}: {
  value: BeatActions
  children: ReactNode
}) => <BeatActionsContext.Provider value={value}>{children}</BeatActionsContext.Provider>

export const useBeatActions = () => useContext(BeatActionsContext)
